import { useState } from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import AverageDowntimeByToolpusherFilters from "./averageDowntimeByToolpusherFilters";
import AverageDowntimeByToolpusherBody from './averageDowntimeByToolpusherBody';
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Average downtime by toolpusher component
 * @returns {JSX.Element}
 * @constructor
 */

const AverageDowntimeByToolpusher = () => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        date: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Average Downtime By Toolpusher" parent="Downtime"/>
            <div className="s-downtime-report">
                <AverageDowntimeByToolpusherFilters {...{data, setData, setFilters}} />
                <AverageDowntimeByToolpusherBody {...{filters, data}} />
            </div>
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default AverageDowntimeByToolpusher;
